<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19hKMbM/tc-custom/9780316054805.jpg?1731155995598" alt="This image is the cover for the book Aging Well"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Aging Well
      </h1>
      <p class="bookDescription body article font2">
        <b>“An outstanding contribution to the study of aging” from a psychiatrist and professor at Harvard Medical School (<i>Publishers Weekly</i>).</b><br/><br/>In an unprecedented series of studies, Harvard Medical School has followed 824 subjects—men and women, some rich, some poor—from their teens to old age. Harvard's George Vaillant now uses these studies—the most complete ever done anywhere in the world—and the subjects' individual histories to illustrate the factors involved in reaching a happy, healthy old age.<br/><br/>He explains precisely why some people turn out to be more resilient than others, the complicated effects of marriage and divorce, negative personality changes, and how to live a more fulfilling, satisfying and rewarding life in the later years. He shows why a person's background has less to do with their eventual happiness than the specific lifestyle choices they make. And he offers step-by-step advice about how each of us can change our lifestyles and age successfully. Sure to be debated on talk shows and in living rooms, Vaillant's definitive and inspiring book is the new classic account of how we live and how we can live better. It will receive massive media attention, and with good reason: we have never seen anything like it, and what it has to tell us will make all the difference in the world.<br/><br/> “A respected researcher. . . . offers suggestions for successful and happy aging. Highly recommended.” —<i>Library Journal</i><br/><br/>“Astonishing observations. . . . [<i>Aging Well</i>] provides the only available longitudinal assessment of the factors that will permit us to age well.” —<i>New England Journal of Medicine</i><br/><br/>“Perceptive, understanding, and often tinged with delightful humor.” —<i>Booklist</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George E. Vaillant
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Little, Brown Spark
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0739f5aa